/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 明細アップロード結果のメタ情報
 * @export
 * @interface GetOperationDetail200Response
 */
export interface GetOperationDetail200Response {
    /**
     * アップロード操作ID
     * @type {string}
     * @memberof GetOperationDetail200Response
     */
    operationUploadId: string;
    /**
     * アップロード日時
     * @type {Date}
     * @memberof GetOperationDetail200Response
     */
    uploadedAt: Date;
    /**
     * Zip内のファイル数
     * @type {number}
     * @memberof GetOperationDetail200Response
     */
    fileCount: number;
    /**
     * Zip内のファイル名一覧
     * @type {Array<string>}
     * @memberof GetOperationDetail200Response
     */
    fileNames: Array<string>;
    /**
     * 対象の支払業務ID
     * @type {string}
     * @memberof GetOperationDetail200Response
     */
    operationId: string;
    /**
     * サービス名
     * @type {string}
     * @memberof GetOperationDetail200Response
     */
    serviceName: string;
    /**
     * 支払集計日
     * @type {Date}
     * @memberof GetOperationDetail200Response
     */
    paymentDate: Date;
    /**
     * アップロード成功件数
     * @type {number}
     * @memberof GetOperationDetail200Response
     */
    successCount: number;
}

/**
 * Check if a given object implements the GetOperationDetail200Response interface.
 */
export function instanceOfGetOperationDetail200Response(value: object): value is GetOperationDetail200Response {
    if (!('operationUploadId' in value) || value['operationUploadId'] === undefined) return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined) return false;
    if (!('fileCount' in value) || value['fileCount'] === undefined) return false;
    if (!('fileNames' in value) || value['fileNames'] === undefined) return false;
    if (!('operationId' in value) || value['operationId'] === undefined) return false;
    if (!('serviceName' in value) || value['serviceName'] === undefined) return false;
    if (!('paymentDate' in value) || value['paymentDate'] === undefined) return false;
    if (!('successCount' in value) || value['successCount'] === undefined) return false;
    return true;
}

export function GetOperationDetail200ResponseFromJSON(json: any): GetOperationDetail200Response {
    return GetOperationDetail200ResponseFromJSONTyped(json, false);
}

export function GetOperationDetail200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOperationDetail200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'operationUploadId': json['operation_upload_id'],
        'uploadedAt': (new Date(json['uploaded_at'])),
        'fileCount': json['file_count'],
        'fileNames': json['file_names'],
        'operationId': json['operation_id'],
        'serviceName': json['service_name'],
        'paymentDate': (new Date(json['payment_date'])),
        'successCount': json['success_count'],
    };
}

export function GetOperationDetail200ResponseToJSON(json: any): GetOperationDetail200Response {
    return GetOperationDetail200ResponseToJSONTyped(json, false);
}

export function GetOperationDetail200ResponseToJSONTyped(value?: GetOperationDetail200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation_upload_id': value['operationUploadId'],
        'uploaded_at': ((value['uploadedAt']).toISOString()),
        'file_count': value['fileCount'],
        'file_names': value['fileNames'],
        'operation_id': value['operationId'],
        'service_name': value['serviceName'],
        'payment_date': ((value['paymentDate']).toISOString().substring(0,10)),
        'success_count': value['successCount'],
    };
}

